import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dropdown from './../Dropdown';

import { userSetFieldFetch } from './../../store/user/actions';

const fieldName = 'password';

class PasswordDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputValue: ''
        };

        this.onChange = this.onChange.bind(this);
        this.save = this.save.bind(this);
    }

    onChange(event) {
        const inputValue = event.target.value;
        this.setState({ inputValue });
    }

    save(event) {
        const { inputValue } = this.state;
        const { save } = this.props;
        save(inputValue);
        this.setState({ inputValue: '' });
    }

    render() {
        const { inputValue } = this.state;
        return (
            <Dropdown buttonClassName="lnk-dropdown" text="password">
                <input className="input-text mb10" type="password" maxLength="100" onChange={this.onChange} autoFocus value={inputValue} placeholder="Enter your password" />
                <button className="btn btn-bright btn-block ta-center" onClick={this.save} data-dropdown="close" disabled={!inputValue}>Update</button>
            </Dropdown>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    save: value => dispatch(userSetFieldFetch(fieldName, value))
});

export default connect(null, mapDispatchToProps)(PasswordDropdown);


// WEBPACK FOOTER //
// ./src/components/profile/PasswordDropdown.js